export const BULK_PERMISSIONS_ASYNC_FF = 'confluence.frontend.bulk.set.space.permission.async';
export const ANALYTICS_SOURCE = 'bulkSpacePermissionsScreen';
